
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';
import { Card } from '../../components/base/Card';

export default function VisionMissionPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero */}
      <section className="pt-24 pb-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-[28px] font-bold text-[#0e3851] mb-4">
              Vizyon & Misyon
            </h1>
            <p className="text-[16px] text-gray-600 max-w-3xl mx-auto">
              Geleceğe yönelik hedeflerimiz ve değerlerimiz doğrultusunda 
              sürdürülebilir inşaat çözümleri sunuyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Vizyon & Misyon */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Vizyon */}
            <Card className="h-full">
              <div className="text-center mb-6">
                <div className="w-16 h-16 flex items-center justify-center bg-[#0e3851]/10 rounded-full mx-auto mb-4">
                  <i className="ri-eye-line text-[28px] text-[#0e3851]"></i>
                </div>
                <h2 className="text-[22px] font-semibold text-[#0e3851]">Vizyonumuz</h2>
              </div>
              <div className="space-y-4 text-[15px] text-gray-600">
                <p>
                  Türkiye'nin önde gelen inşaat firmalarından biri olarak, 
                  sürdürülebilir ve çevre dostu yapılar inşa ederek gelecek 
                  nesillere yaşanabilir bir dünya bırakmak.
                </p>
                <p>
                  Teknoloji ve inovasyonu inşaat sektöründe öncü bir şekilde 
                  kullanarak, akıllı binalar ve sürdürülebilir kentsel dönüşüm 
                  projelerinde sektöre yön vermek.
                </p>
                <p>
                  Uluslararası standartlarda kalite anlayışı ile hem yerel hem de 
                  global pazarlarda güvenilir bir marka olmak.
                </p>
              </div>
            </Card>

            {/* Misyon */}
            <Card className="h-full">
              <div className="text-center mb-6">
                <div className="w-16 h-16 flex items-center justify-center bg-[#0e3851]/10 rounded-full mx-auto mb-4">
                  <i className="ri-target-line text-[28px] text-[#0e3851]"></i>
                </div>
                <h2 className="text-[22px] font-semibold text-[#0e3851]">Misyonumuz</h2>
              </div>
              <div className="space-y-4 text-[15px] text-gray-600">
                <p>
                  Müşterilerimizin hayallerini gerçeğe dönüştürmek için kaliteli 
                  malzeme, deneyimli ekip ve modern teknoloji kullanarak zamanında 
                  ve bütçe dahilinde projeler teslim etmek.
                </p>
                <p>
                  İş güvenliği standartlarına tam uyum sağlayarak, çalışanlarımızın 
                  ve müşterilerimizin güvenliğini her şeyin üstünde tutmak.
                </p>
                <p>
                  Şeffaf iş süreçleri ve müşteri odaklı yaklaşımla sektörde 
                  güvenilirlik ve kalite standardı olmak.
                </p>
              </div>
            </Card>
          </div>
        </div>
      </section>

      {/* Değerlerimiz */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-[22px] font-semibold text-[#0e3851] mb-4">Değerlerimiz</h2>
            <p className="text-[15px] text-gray-600 max-w-2xl mx-auto">
              Çalışma prensiplerimizi belirleyen temel değerler
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <Card className="text-center" hover>
              <div className="w-12 h-12 flex items-center justify-center bg-[#0e3851] rounded-xl mx-auto mb-4">
                <i className="ri-shield-check-line text-[20px] text-white"></i>
              </div>
              <h3 className="text-[18px] font-semibold text-[#0e3851] mb-2">Güvenilirlik</h3>
              <p className="text-[15px] text-gray-600">
                Sözümüzün arkasında durarak müşterilerimizle uzun vadeli güven ilişkisi kuruyoruz.
              </p>
            </Card>

            <Card className="text-center" hover>
              <div className="w-12 h-12 flex items-center justify-center bg-[#0e3851] rounded-xl mx-auto mb-4">
                <i className="ri-award-line text-[20px] text-white"></i>
              </div>
              <h3 className="text-[18px] font-semibold text-[#0e3851] mb-2">Kalite</h3>
              <p className="text-[15px] text-gray-600">
                Her projemizde en yüksek kalite standartlarını uygulayarak mükemmelliği hedefliyoruz.
              </p>
            </Card>

            <Card className="text-center" hover>
              <div className="w-12 h-12 flex items-center justify-center bg-[#0e3851] rounded-xl mx-auto mb-4">
                <i className="ri-leaf-line text-[20px] text-white"></i>
              </div>
              <h3 className="text-[18px] font-semibold text-[#0e3851] mb-2">Sürdürülebilirlik</h3>
              <p className="text-[15px] text-gray-600">
                Çevre dostu malzemeler ve enerji verimli çözümlerle geleceği düşünüyoruz.
              </p>
            </Card>

            <Card className="text-center" hover>
              <div className="w-12 h-12 flex items-center justify-center bg-[#0e3851] rounded-xl mx-auto mb-4">
                <i className="ri-team-line text-[20px] text-white"></i>
              </div>
              <h3 className="text-[18px] font-semibold text-[#0e3851] mb-2">Takım Çalışması</h3>
              <p className="text-[15px] text-gray-600">
                Deneyimli ekibimizle koordineli çalışarak başarılı sonuçlar elde ediyoruz.
              </p>
            </Card>

            <Card className="text-center" hover>
              <div className="w-12 h-12 flex items-center justify-center bg-[#0e3851] rounded-xl mx-auto mb-4">
                <i className="ri-lightbulb-line text-[20px] text-white"></i>
              </div>
              <h3 className="text-[18px] font-semibold text-[#0e3851] mb-2">İnovasyon</h3>
              <p className="text-[15px] text-gray-600">
                Yeni teknolojiler ve yaratıcı çözümlerle sektöre öncülük ediyoruz.
              </p>
            </Card>

            <Card className="text-center" hover>
              <div className="w-12 h-12 flex items-center justify-center bg-[#0e3851] rounded-xl mx-auto mb-4">
                <i className="ri-eye-line text-[20px] text-white"></i>
              </div>
              <h3 className="text-[18px] font-semibold text-[#0e3851] mb-2">Şeffaflık</h3>
              <p className="text-[15px] text-gray-600">
                Tüm süreçlerimizde açık ve net iletişim kurarak güven oluşturuyoruz.
              </p>
            </Card>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
